import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Growth")
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  key: 0,
  class: "alert alert-danger mb-0"
}
const _hoisted_5 = {
  key: 1,
  class: "placeholder-glow"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "placeholder col-12",
  style: {"height":"300px"}
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "row mb-4" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-muted" }, "Onboarding completion", -1)
const _hoisted_11 = { class: "fs-2 fw-bold" }
const _hoisted_12 = { class: "mt-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-muted mb-2" }, "Onboarding funnel", -1)
const _hoisted_14 = {
  key: 0,
  class: "text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.error), 1))
        : (_ctx.loading && !_ctx.loaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, _toDisplayString(((_ctx.growth.completionRate ?? 0) * 100).toFixed(1)) + "% ", 1)
                ])
              ]),
              _createVNode(_component_apexchart, {
                type: "line",
                height: "300",
                options: _ctx.chartOptions,
                series: _ctx.series
              }, null, 8, ["options", "series"]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                (_ctx.funnel.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, "No funnel data for this range."))
                  : (_openBlock(), _createBlock(_component_apexchart, {
                      key: 1,
                      type: "bar",
                      height: "260",
                      options: _ctx.funnelOptions,
                      series: _ctx.funnelSeries
                    }, null, 8, ["options", "series"]))
              ])
            ], 64))
    ])
  ]))
}